import { requestWrapper } from '@/utils/axiosInstance';

export default {
  async getAll() {
    return await requestWrapper(null, 'GET', `/classifiers_tables`);
  },
  async create(table) {
    return await requestWrapper(null, 'POST', '/classifiers_tables', null, table);
  },
  async get(id) {
    return await requestWrapper(null, 'GET', `/classifiers_tables/${id}`);
  },
  async update(table) {
    return await requestWrapper(null, 'PUT', `/classifiers_tables/${table.id}`, null, table);
  },
  async remove(id) {
    return await requestWrapper(null, 'DELETE', `/classifiers_tables/${id}`);
  },
};
